import { render } from "./PackageInfoModal.vue?vue&type=template&id=188ad886"
import script from "./PackageInfoModal.vue?vue&type=script&lang=js"
export * from "./PackageInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "/projects/inxure-hub/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__